export const roles = {
  Researcher: '',
  Entrepreneur: '',
  'Venture Capital': '',
  'Family Office': '',
  Corporate: '',
  Philanthropic: '',
  'Professional Society': '',
  'Governmental/NGO': '',
  'University Administration': '',
  Other: '',
};

export const researcher = [
  'Master’s student',
  'PhD Student',
  'Postdoc',
  'Research Fellow',
  'Assistant Professor',
  'Visiting Scholar',
  'Associate Professor',
  'Professor',
  'Endowed Professor',
];

export const university_admin = [
  'Administrative',
  'Research Grant Officer',
  'Conference Organizer',
];
